import { queryOptions } from '@tanstack/react-query';

import type { NotificationsPageData } from './get-notifications-page-data.ts';
import { getNotificationsPageData } from './get-notifications-page-data.ts';

export const NOTIFICATIONS_PAGE_QUERY_KEY = ['notifications-page'] as const;

export function getNotificationsPageDataQueryOptions() {
	return queryOptions<NotificationsPageData>({
		queryFn: () => getNotificationsPageData(),
		queryKey: NOTIFICATIONS_PAGE_QUERY_KEY,
	});
}
